import React from 'react';

interface ExerciseCompleteModalProps {
  isLastExercise: boolean;
  exerciseName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * ExerciseCompleteModal - Modal shown when all planned sets are completed
 * Styled similar to RestTimer for consistency
 */
export const ExerciseCompleteModal: React.FC<ExerciseCompleteModalProps> = ({
  isLastExercise,
  exerciseName,
  onConfirm,
  onCancel
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4 text-center">
        {/* Header */}
        <div className="mb-4">
          <div className="text-4xl mb-3">✅</div>
          <h3 className="text-lg font-semibold text-gray-800 mb-2">
            Все подходы выполнены!
          </h3>
          <p className="text-sm text-gray-600">
            {exerciseName}
          </p>
        </div>

        {/* Message */}
        <div className="mb-6">
          <p className="text-gray-700">
            {isLastExercise 
              ? 'Все упражнения выполнены! Завершить тренировку?'
              : 'Перейти к следующему упражнению?'
            }
          </p>
          <p className="text-xs text-gray-500 mt-2">
            Нажмите "Отмена", если хотите добавить дополнительные подходы
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-3">
          <button
            onClick={onConfirm}
            className="flex-1 bg-green-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-green-700"
          >
            {isLastExercise ? 'Завершить тренировку' : 'Перейти к следующему'}
          </button>
          <button
            onClick={onCancel}
            className="px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExerciseCompleteModal;
